<template lang="html">
  <div class="auth__checkbox-wrapper">
    <input
      :id="uniqId"
      class="auth__checkbox"
      type="checkbox"
      :name="name"
      :disabled="disabled"
      :checked="value"
      @input="onInput"
    >
    <label
      class="auth__checkbox-label"
      :for="uniqId"
      v-html="label"
    />
  </div>
  <span
    v-if="observableError"
    class="auth__hint auth__hint--error"
  >{{ observableError }}</span>
</template>

<script lang="js">
import { defineComponent } from 'vue';
import ValidationFormMixin from '@/utils/validate2/validation-form-mixin.js';

export default defineComponent({
  name: 'CheckboxForm',
  mixins: [ValidationFormMixin],
  props: {
    value: Boolean,
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    disabled: Boolean,
  },
  computed: {
    uniqId() {
      return `checkbox-${Math.random()}`;
    },
  },
  methods: {
    onInput(e) {
      this.$emit('update:value', e.target.checked);
      this.blurValidateForm();
    },
  },
});
</script>

<style lang="scss">
.auth__checkbox-label a {
  color: $color-green-primary;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>
